<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">首页</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      团购管理
      <small>管理商城的各种活动...</small>
    </h1>
    <!-- end page-header -->
    <panel title="团购列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add">
          <i class="fa fa-plus"></i> 添加团购
        </button>
      </div>

      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.name" placeholder="名称"></Input>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>

      <Table border size="small" :columns="columns" :data="data" class="m-t-10">
        <template slot-scope="{row}" slot="beginenddate">
          开始:{{row.begintime}}
          <br />
          结束:{{row.endtime}}
        </template>
        <template slot-scope="{row}" slot="iscreated">
          <span v-if="row.iscreated ==0">未成团</span>
          <span style="color:blue" v-else-if="row.iscreated ==1">
            已成团
            <i class="fa fa-check"></i>
          </span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row,index)"
          >团购管理</button>

          <Poptip
            transfer
            v-if="row.currentmember == 0"
            confirm
            title="是否要删除此团购?"
            @on-ok="fn_remove(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>

    <Drawer title="活动管理" v-model="v_edit" width="60" :mask-closable="true">
      <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
        <Row>
          <Col span="12">
            <FormItem label="名称" prop="name">
              <Input v-model="formData.name" />
            </FormItem>
            <FormItem label="团购商品" prop="goods_name">
              <AutoComplete
                v-model="formData.goods_name"
                @on-search="handleSearchGoods"
                @on-select="fn_change_goods"
                placeholder="团购商品名称"
                style="width:100%"
              >
                <Option
                  v-for="(item,index) in searchResultList"
                  :value="item.goods_name"
                  :label="item.goods_name"
                  :key="index"
                >{{ item.goods_name }}</Option>
              </AutoComplete>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="开始时间" prop="begindate">
              <DatePicker type="datetime" style="width:100%" v-model="formData.begintime" />
            </FormItem>
            <FormItem label="结束时间" prop="enddate">
              <DatePicker type="datetime" style="width:100%" v-model="formData.endtime" />
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="最小成团人数">
              <InputNumber style="width:100%" v-model="formData.memberminnum"></InputNumber>
            </FormItem>
            <FormItem label="最大成团人数">
              <InputNumber style="width:100%" v-model="formData.membermaxnum"></InputNumber>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="备注" prop="remarks">
          <Input type="textarea" :rows="5" v-model="formData.remarks" />
        </FormItem>
      </Form>

      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="v_edit = false">关闭</Button>
        <Button type="primary" @click="fn_store_groupbuy">保存</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import {
  getGroupBuyList,
  searchGoodsList,
  storeGroupBuyData,
  storeActivityData
} from "@/api/groupbuy";

import moment from "moment";

import { getToken } from "@/libs/util";
import config from "@/config";
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.css";

export default {
  data() {
    return {
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      filterCond: {
        page: 1,
        pageNum: 10,
        name: ""
      },
      columns: [
        {
          title: "#",
          key: "id",
          width: 50
        },
        {
          title: "名称",
          key: "name",
          width: 200
        },
        {
          title: "商品名称",
          key: "goods_name",
          width: 200
        },
        {
          title: "时间",
          slot: "beginenddate",
          width: 180
        },
        {
          title: "成团数量",
          key: "memberminnum",
          width: 70
        },
        {
          title: "最多成团数量",
          key: "membermaxnum",
          width: 100
        },
        {
          title: "当前参团人数",
          key: "currentmember",
          width: 90
        },
        {
          title: "是否成团",
          slot: "iscreated",
          width: 90
        },
        {
          title: "备注",
          key: "remarks"
        },

        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "left",
          fixed: "right"
        }
      ],
      data: [],

      totalRows: 0,
      pageNum: 10,
      currentPage: 1,

      formData: {},
      rules: {
        goods_name: [
          {
            required: true,
            message: "商品必填",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "名称必填",
            trigger: "blur"
          }
        ]
      },
      searchResultList: [],
      v_edit: false
    };
  },
  mounted() {
    this.filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(this.filterCond);
  },

  methods: {
    handleSearchGoods(node) {
      //   console.log(node);
      searchGoodsList(node)
        .then(res => {
          this.searchResultList = res.data;
        })
        .catch(error => {
          this.$Message.error("error" + error);
        });
    },
    fn_change_goods(node) {
      this.formData.goodsid = this.searchResultList[node].id;
    },

    fn_query() {
      this.filterCond.page = 1;
      this.fn_load_data(this.filterCond);
    },
    fn_add() {
      this.v_edit = true;
      this.formData = {
        id: 0,
        name: "",
        goodsid: 0,
        goods_name: "",
        begintime: moment().format("YYYY-MM-DD HH:mm:ss"),
        endtime: moment()
          .add(30, "day")
          .format("YYYY-MM-DD HH:mm:ss"),
        iscreated: 0,
        remarks: "",
        memberminnum: 1,
        membermaxnum: 100000,
        currentmember: 0,
        status: 0
      };
      console.log(this.formData);
    },
    fn_load_data(filterCond) {
      getGroupBuyList(filterCond)
        .then(res => {
          this.data = res.data.data;
          this.totalRows = res.data.total;
        })
        .catch(error => {
          this.$Message.error("error:" + error);
        });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_edit(row, index) {
      this.formData = row;
      this.v_edit = true;
    },

    fn_store_groupbuy() {
      //   console.log(this.searchResultList);
      if (this.searchResultList.length > 0) {
        this.formData.goodsid = this.searchResultList[
          this.formData.goods_name
        ].id;
      }

      if (this.formData.goodsid == 0) {
        this.$Message.error("还没有选择团购商品");
        return;
      }
      this.formData.begintime = moment(this.formData.begintime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formData.endtime = moment(this.formData.endtime).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      this.$refs.formData.validate(valid => {
        console.log("valid", valid);
        if (valid) {
          console.log(this.formData);
          storeGroupBuyData(this.formData)
            .then(res => {
              if (res.data.code == 200) {
                if (this.formData.id == 0) {
                  this.fn_switchPage(1);
                }
                this.v_edit = false;
                this.$Notice.success({
                  title: "成功",
                  desc: res.data.desc
                });
              } else {
                this.$Notice.error({
                  title: "失败",
                  desc: res.data.desc
                });
              }
            })
            .catch(error => {
              this.$Message.error("error" + error);
            });
        }
      });
    },
    fn_remove(row, index) {
      removeActivityData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_remove_item(item, index) {
      if (item.id > 0) {
        removeActivityDataItem(item.id).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.formDataItem.splice(index, 1);
          } else {
            this.$Notice.error(res.data);
          }
        });
      } else {
        this.formDataItem.splice(index, 1);
      }
    }
  }
};
</script>
